var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb8",attrs:{"text":""},on:{"click":function($event){return _vm.$router.push(_vm.to ? _vm.to : '/empresas')}}},[_c('v-icon',{staticStyle:{"margin-right":"8px"},attrs:{"small":""},domProps:{"textContent":_vm._s('arrow_back')}}),_vm._v(" "+_vm._s(_vm.text ? _vm.text: 'Volver al inicio')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }